import React from "react";

/**
 * Branded share buttons. Pre-fills with logo (via OG), title + timestamp + attribution.
 */
export default function ShareButtons({ post }) {
  if (!post) return null;
  const origin = typeof window !== "undefined" ? window.location.origin : "https://www.xaelserpent.com";
  const url = `${origin}/articles/${post.slug}`;
  const stamp = post.published_at ? new Date(post.published_at).toISOString().slice(0, 10) : "";
  const text = `${post.title} — Original from xaelserpent.com (${stamp}) <img src="/bolt.png" alt="" className="inline-block h-4 w-4 align-middle" />`;

  const twitter = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}&via=xaelserpent`;
  const facebook = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(text)}`;
  const reddit = `https://www.reddit.com/submit?url=${encodeURIComponent(url)}&title=${encodeURIComponent(post.title)}`;
  const copy = () => {
    navigator.clipboard?.writeText(url);
  };

  return (
    <div data-testid="share-buttons" style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 16 }}>
      <a
        href={twitter}
        target="_blank"
        rel="noreferrer"
        className="xs-btn"
        data-testid="share-twitter"
      >
        ✕ share on x
      </a>
      <a
        href={facebook}
        target="_blank"
        rel="noreferrer"
        className="xs-btn"
        data-testid="share-facebook"
      >
        ƒ share on facebook
      </a>
      <a
        href={reddit}
        target="_blank"
        rel="noreferrer"
        className="xs-btn"
        data-testid="share-reddit"
      >
        ↗ reddit
      </a>
      <button className="xs-btn ghost" onClick={copy} data-testid="share-copy">
        copy link
      </button>
    </div>
  );
}
